<template>
  <div v-if="advancement && advancement.olympiadExam" class="olympiad-outcome">
    <div
      v-if="advancement.advancementKind === 'IMMEDIATE' && advancement.phasePassed"
      class="olympiad-outcome__box olympiad-outcome__box--success"
    >
      <p class="olympiad-outcome__title">¡Felicitaciones!</p>
      <p>
        Clasificaste a la siguiente fase
        <strong v-if="advancement.nextPhaseName">({{ advancement.nextPhaseName }})</strong>.
        Ya puedes empezar a prepararte.
      </p>
    </div>

    <div
      v-else-if="advancement.advancementKind === 'IMMEDIATE' && !advancement.phasePassed"
      class="olympiad-outcome__box olympiad-outcome__box--muted"
    >
      <p>En esta ocasión no clasificaste a la siguiente fase. ¡Sigue practicando!</p>
    </div>

    <div
      v-else-if="advancement.advancementKind === 'RANKING'"
      class="olympiad-outcome__box olympiad-outcome__box--info"
    >
      <p>
        Tu resultado se evaluará según el ranking de la fase (según tu examen más reciente).
        Revisa el ranking cuando esté publicado para saber si clasificaste.
      </p>
    </div>

    <p v-if="advancement.canonicalExamTitle" class="olympiad-outcome__hint">
      Si presentas otro examen de esta fase, tu posición usará el más reciente
      (actualmente: {{ advancement.canonicalExamTitle }}).
    </p>

    <router-link
      v-if="advancement.rankingReleased && rankingLink"
      :to="rankingLink"
      class="olympiad-outcome__link"
    >
      Ver ranking de la fase
    </router-link>
    <p v-else-if="advancement.advancementKind === 'RANKING'" class="olympiad-outcome__hint">
      El ranking aún no está disponible.
    </p>
  </div>
</template>

<script>
export default {
  name: "OlympiadExamOutcomeBanner",
  props: {
    advancement: { type: Object, default: null },
    slug: { type: String, default: null },
    olympicId: { type: [Number, String], default: null },
  },
  computed: {
    rankingLink() {
      if (!this.advancement || !this.advancement.phaseId) return null;
      const phaseId = this.advancement.phaseId;
      const query = {};
      if (this.olympicId) query.olympicId = this.olympicId;
      if (this.slug) query.slug = this.slug;
      const course = this.$store?.state?.course?.current;
      if (course?.id) query.moduleId = course.id;

      if (this.slug) {
        return { path: `/olimpiadas/${this.slug}/fases/${phaseId}/ranking`, query };
      }
      if (this.olympicId) {
        return { path: `/olimpiadas/id/${this.olympicId}/fases/${phaseId}/ranking`, query };
      }
      return this.advancement.rankingUrl || null;
    },
  },
};
</script>

<style scoped>
.olympiad-outcome {
  margin-top: 1.25rem;
  text-align: center;
}
.olympiad-outcome__box {
  border-radius: 12px;
  padding: 1rem 1.25rem;
  margin-bottom: 0.75rem;
}
.olympiad-outcome__box--success {
  background: #e8f5e9;
  color: #1b5e20;
}
.olympiad-outcome__box--muted {
  background: #f5f5f5;
  color: #424242;
}
.olympiad-outcome__box--info {
  background: #e3f2fd;
  color: #0d47a1;
}
.olympiad-outcome__title {
  font-weight: 700;
  margin-bottom: 0.35rem;
}
.olympiad-outcome__link {
  display: inline-block;
  margin-top: 0.5rem;
  color: #656ec9;
  font-weight: 600;
  text-decoration: underline;
}
.olympiad-outcome__hint {
  font-size: 0.875rem;
  color: #616161;
  margin-top: 0.5rem;
}
</style>
